<script lang="ts">
    export let partner:any [];

</script>


<div class="container-fluid py-md-5 py-5" id="section-partner">
	<div class="container">
		<div class="row g-0 border border-1 border-dark rounded-0 p-3 py-4 py-md-5 position-relative">
			<span class="bg-white px-3 text-center text-md-start position-absolute logo-partner-top">
				<img alt="IHG" src="/img/logo-ihg.png" class="logo-ihg-partner">
			</span>
			<div class="col-md-12 py-md-4 py-3">
				<div class="row g-0 w-100 justify-content-between align-items-center">
                    {#each partner as item}
					<a href="{item?.link}" target="_blank" class="col-4 col-md-1 m-md-2 p-md-0 p-3 mt-3">
						<img alt="IHG Partner" src="{item?.featured_images[0]?.path}" class="logo-partner w-100">
					</a>
                    {/each}
				</div>
			</div>
			<span class="bg-white px-3 text-center text-md-end position-absolute logo-partner-bottom">
				<img alt="IHG" src="/img/logo-ihg-2.png" class="logo-ihg-partner">
			</span>
		</div>
	</div>
</div>

<style type="text/css">
	#section-partner .logo-ihg-partner{
		width: 250px;
	}
	#section-partner .logo-partner{
		width: 100%;
	}
	#section-partner .logo-partner-top{
		left: 5%;
		top: -8%;
		width: fit-content;
	}
	#section-partner .logo-partner-bottom{
		right: 5%;
		bottom: -8%;
		width: fit-content;
	}
	@media (max-width: 600px) {
		#section-partner .logo-ihg-partner{
			width: 150px;
		}
		#section-partner .logo-partner-top{
			left: 50%;
			top: -2.5%;
			width: fit-content;
			transform: translateX(-50%);
		}
		#section-partner .logo-partner-bottom{
			left: 50%;
			bottom: -2.5%;
			width: fit-content;
			transform: translateX(-50%);
		}
	}
</style>